// extracted by mini-css-extract-plugin
export default {"createDropdownContainer":"MediaUploadButton__createDropdownContainer___QlWIJ"};